import { render } from "./FormPage.vue?vue&type=template&id=1011c4a6&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"

import "./FormPage.vue?vue&type=style&index=0&id=1011c4a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1011c4a6"],['__file',"src/components/h5/layout/FormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1011c4a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1011c4a6', __exports__)) {
    api.reload('1011c4a6', __exports__)
  }
  
  module.hot.accept("./FormPage.vue?vue&type=template&id=1011c4a6&scoped=true", () => {
    api.rerender('1011c4a6', render)
  })

}


export default __exports__